export const normalizeValue = value => {
  if (!value) return ''
  return value.toString().toLowerCase()
}

export const buildAllInterest = tenantId => {
  if (!tenantId) return null
  return `all-${tenantId}`
}

export const buildUserInterest = (tenantId, username) => {
  if (!tenantId || !username) return null
  return `user-${tenantId}-${normalizeValue(username)}`
}

export const buildRoleInterest = (tenantId, role) => {
  if (!tenantId || !role) return null
  return `role-${tenantId}-${normalizeValue(role)}`
}

export default {
  buildAllInterest,
  buildUserInterest,
  buildRoleInterest,
}
